import { Suspense, lazy } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';
import TaskStatusPage from '../../pages/campaign/task-status';

// ----------------------------------------------------------------------

// const IndexPage = lazy(() => import('src/pages/campaign'));
const CreateCampaignPage = lazy(() => import('src/pages/campaign/create-campaign'));
const CampaignsEdit = lazy(() => import('src/sections/superadmin/organization-campaigns-edit'));
const TasksPage = lazy(() => import('src/pages/campaign/tasks'));
const ManualBatchTasksPage = lazy(() => import('src/pages/campaign/manual-batch-tasks'));
const TaskDetailPage = lazy(() => import('src/pages/campaign/task-details'));
const TaskCreatePage = lazy(() => import('src/pages/campaign/task-create'));
const TaskEditPage = lazy(() => import('src/pages/campaign/task-edit'));
const TaskFollowUpPage = lazy(() => import('src/pages/campaign/task-follow-up'));
const ResultsPage = lazy(() => import('src/pages/campaign/results'));
const ResultViewPage = lazy(() => import('src/pages/campaign/result-view'));
const VolunteersPage = lazy(() => import('src/pages/volunteers/list'));
const VolunteerAddPage = lazy(() => import('src/pages/volunteers/add'));
const VolunteerEditPage = lazy(() => import('src/pages/volunteers/edit'));

// ----------------------------------------------------------------------

export const campaigndRoutes = [
  {
    path: 'campaigns',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      {
        path: ':orgId/create',
        element: <CreateCampaignPage />,
      },
      {
        path: ':id/:orgId/edit',
        element: <CampaignsEdit />,
      },
      {
        path: 'manual-text-batch/:batchId/tasks',
        element: <ManualBatchTasksPage />,
      },
      {
        path: ':campaignId/tasks',
        element: <TasksPage />,
      },
      {
        path: ':campaignId/tasks/create',
        element: <TaskCreatePage />,
      },
      {
        path: ':campaignId/tasks/:id',
        element: <TaskDetailPage />,
      },
      {
        path: ':campaignId/tasks/:taskId/edit',
        element: <TaskEditPage />,
      },
      {
        path: ':campaignId/tasks/:taskId/status',
        element: <TaskStatusPage />,
      },
      {
        path: ':campaignId/tasks/:taskId/follow_up',
        element: <TaskFollowUpPage />,
      },
      {
        path: ':campaignId/results',
        element: <ResultsPage />,
      },
      {
        path: ':campaignId/results/:resultId',
        element: <ResultViewPage />,
      },
      {
        path: ':campaignId/volunteers',
        element: <VolunteersPage />,
      },
      {
        path: ':campaignId/volunteers/add',
        element: <VolunteerAddPage />,
      },
      {
        path: ':campaignId/volunteers/:userId/edit',
        element: <VolunteerEditPage />,
      },
    ],
  },
];
